// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { Amount, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const titleStyles = (breakpoints: Array<Amount | null>, fontFamily: "title" | "base") => css`
    ${spacingStyles("1em", "0.5em")}
    ${breakpointValues(pxToRemArray(breakpoints), "font-size")}
    color: ${getColor("text.dark")};
    font-family: ${({ theme }) => theme.design.typography.fontFamily[fontFamily]};
`;

const typography: Styleguide["typography"] = {
    fontFamilyImportUrl: `https://fonts.googleapis.com/css2?family=Archivo+Narrow:wght@400;700&family=Nunito+Sans:wght@400;700&display=swap`,

    body: {
        size: "inherit",
        weight: "inherit",
        fontFamily: "inherit",
        css: css`
            ${({ theme }) => `
                font-weight: ${theme.design.typography.weight.base};
                font-family: ${theme.design.typography.fontFamily.base};
                font-size: ${theme.design.typography.size.base};
                line-height: ${theme.design.typography.lineHeight.base};
            `}
        `,
    },
    p: {
        size: "inherit",
        weight: "inherit",
        css: css`
            ${spacingStyles()}
        `,
    },
    h1: {
        css: css`
            line-height: ${x => x.theme.design.typography.lineHeight.small};
            font-weight: ${x => x.theme.design.typography.weight.bold};
            ${titleStyles([null, 31, 37, null, 48], "base")}
        `,
    },
    h2: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
            ${titleStyles([null, null, 28, null, 32], "base")}
            line-height: ${x => x.theme.design.typography.lineHeight.small};
        `,
    },
    h3: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
            ${titleStyles([null, null, 20, null, 24], "base")}
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
    h4: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
            ${titleStyles([null, null, 18, null, 20], "base")}
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
    h5: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
            ${titleStyles([null, null, null, null, 16], "base")}
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
    h6: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
            ${titleStyles([null, null, null, null, 14], "base")}
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
    legend: {
        css: css`
            color: ${getColor("text.accent")};

            ${({ theme }) => `
                font-size: ${theme.design.typography.size.tiny};
                font-weight: ${theme.design.typography.weight.bold};
                line-height: ${theme.design.typography.lineHeight.base};
            `}
        `,
    },
    headerPrimary: {
        css: css`
            ${titleStyles([36, null, 60, null, 70], "title")}
            font-weight: ${x => x.theme.design.typography.weight.bold};
            line-height: ${x => x.theme.design.typography.lineHeight.small};
        `,
    },
    headerSecondary: {
        css: css`
            ${titleStyles([28, null, null, null, 50], "title")}
            font-weight: ${x => x.theme.design.typography.weight.bold};
            line-height: ${x => x.theme.design.typography.lineHeight.small};
        `,
    },
    headerTertiary: {
        css: css`
            ${titleStyles([20, null, null, null, 36], "title")}
            font-weight: ${x => x.theme.design.typography.weight.bold};
            line-height: ${x => x.theme.design.typography.lineHeight.small};
        `,
    },
};

typography.bannerTitle = {
    ...typography.h1,
    forwardAs: "h1",
    css: css`
        ${typography.h1?.css}
        ${breakpointValues(pxToRemArray([16, null, null, null, 20]), "margin-bottom")}
    `,
};

typography.bannerSecondaryTitle = {
    ...typography.h2,
    forwardAs: "h1",
    css: css`
        ${typography.h2?.css}
        ${breakpointValues(pxToRemArray([16, null, null, null, 20]), "margin-bottom")}
    `,
};

export default typography;
